<script>
import {
    eventGroupState
} from '@app/store/eventGroupStore.svelte.js';
import {
    projectState
} from '@app/store/projectStore.svelte.js';
import {
    insertHistoryAction
} from '@app/store/historyStore.svelte.js';
import { onMount, onDestroy } from 'svelte';
import * as m from '@app/paraglide/messages.js';

let open = $state(false);
let positionMenuRef;

const updatePosition = function(posX, posY) {
    eventGroupState[projectState.selected].selected.forEach(eventIndex => {
        // console.log(`Updating event ${eventIndex} position to ${posX}, ${posY}`);
        switch (posY) {
            case "top":
                eventGroupState[projectState.selected].events[eventIndex].yPos = "start"
                break;
            case "center":
                eventGroupState[projectState.selected].events[eventIndex].yPos = "center"
                break;
            default:
                eventGroupState[projectState.selected].events[eventIndex].yPos = "end"
        }

        switch (posX) {
            case "left":
                eventGroupState[projectState.selected].events[eventIndex].xPos = "start";
                break;
            case "center":
                eventGroupState[projectState.selected].events[eventIndex].xPos = "center";
                break;
            default:
                eventGroupState[projectState.selected].events[eventIndex].xPos = "end";
        }
        // console.log(eventGroupState[projectState.selected].events[eventIndex]);
    });

    insertHistoryAction({
        name: "position event(s)", //action name
        eventGroup: projectState.selected,
        snapshots: [{
            store: "eventGroupState",
            value: JSON.stringify(eventGroupState)
        }]
    });
    /* Close Menu */
    open = false;
}

// Function to handle clicks outside the dropdown
function handleClickOutside(event) {
    // If the dropdown is open and the click is outside both the button and dropdown
    if (open && positionMenuRef && !positionMenuRef.contains(event.target) && 
        !event.target.closest('#position-dropdown')) {
        open = false;
    }
}

// Toggle dropdown visibility
function toggleDropdown(event) {
    // Prevent default to avoid navigating to "#!" in the href
    event.preventDefault();
    open = !open;
}

// Set up event listener on mount and clean up on destroy
onMount(() => {
    document.addEventListener('mousedown', handleClickOutside);
});

onDestroy(() => {
    document.removeEventListener('mousedown', handleClickOutside);
});
</script>

<li class="nav-item dropdown {open ? 'show' : ''}" role="presentation" title={m.position_title()}>
    <a 
        id="position-dropdown"
        class:disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}
        aria-disabled={!eventGroupState[projectState.selected] || eventGroupState[projectState.selected].selected.length === 0}
        onclick={toggleDropdown} 
        class="dropdown-toggle nav-link" 
        href="#!/"
        aria-expanded={open}
        aria-label={m.position_aria_label()}
        role="button"><i class="bi bi-grid-3x3" aria-hidden="true"></i></a>
    <div id="PositionMenu" 
         class="dropdown-menu {open ? 'show' : ''}" 
         role="menu" 
         aria-labelledby="position-dropdown" 
         bind:this={positionMenuRef}>
        <div class="position-grid" role="toolbar" aria-label={m.position_controls_label()}>
            <!-- Top row -->
            <label class="position-box" title={m.position_top_left_title()}>
                <button 
                    class="position-btn" 
                    type="button" 
                    onclick={() => updatePosition('left', 'top')} 
                    aria-label={m.position_top_left_aria_label()}>
                    <span class="position-indicator"></span>
                </button>
            </label>
            <label class="position-box" title={m.position_top_center_title()}>
                <button 
                    class="position-btn" 
                    type="button" 
                    onclick={() => updatePosition('center', 'top')} 
                    aria-label={m.position_top_center_aria_label()}>
                    <span class="position-indicator"></span>
                </button>
            </label>
            <label class="position-box" title={m.position_top_right_title()}>
                <button 
                    class="position-btn" 
                    type="button" 
                    onclick={() => updatePosition('right', 'top')} 
                    aria-label={m.position_top_right_aria_label()}>
                    <span class="position-indicator"></span>
                </button>
            </label>
            
            <!-- Middle row -->
            <label class="position-box" title={m.position_center_left_title()}>
                <button 
                    class="position-btn" 
                    type="button" 
                    onclick={() => updatePosition('left', 'center')} 
                    aria-label={m.position_center_left_aria_label()}>
                    <span class="position-indicator"></span>
                </button>
            </label>
            <label class="position-box" title={m.position_center_title()}>
                <button 
                    class="position-btn" 
                    type="button" 
                    onclick={() => updatePosition('center', 'center')} 
                    aria-label={m.position_center_aria_label()}>
                    <span class="position-indicator"></span>
                </button>
            </label>
            <label class="position-box" title={m.position_center_right_title()}>
                <button 
                    class="position-btn" 
                    type="button" 
                    onclick={() => updatePosition('right', 'center')} 
                    aria-label={m.position_center_right_aria_label()}>
                    <span class="position-indicator"></span>
                </button>
            </label>
            
            <!-- Bottom row -->
            <label class="position-box" title={m.position_bottom_left_title()}>
                <button 
                    class="position-btn" 
                    type="button" 
                    onclick={() => updatePosition('left', 'bottom')} 
                    aria-label={m.position_bottom_left_aria_label()}>
                    <span class="position-indicator"></span>
                </button>
            </label>
            <label class="position-box" title={m.position_bottom_center_title()}>
                <button 
                    class="position-btn" 
                    type="button" 
                    onclick={() => updatePosition('center', 'bottom')} 
                    aria-label={m.position_bottom_center_aria_label()}>
                    <span class="position-indicator"></span>
                </button>
            </label>
            <label class="position-box" title={m.position_bottom_right_title()}>
                <button 
                    class="position-btn" 
                    type="button" 
                    onclick={() => updatePosition('right', 'bottom')} 
                    aria-label={m.position_bottom_right_aria_label()}>
                    <span class="position-indicator"></span>
                </button>
            </label>
        </div>
    </div>
</li>
<style lang="css">
#PositionMenu {
    background: transparent;
    border: none;
    position: absolute;
    top: 30px;
    padding: 5px;
}

.position-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 4px;
    width: 90px;
    height: 90px;
    background-color: var(--bs-light);
    padding: 6px;
    border-radius: 2px;
    box-shadow: 3px 3px 5px rgb(14, 14, 14);
}

.position-box {
    position: relative;
    aspect-ratio: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 0;
    background-color: var(--bs-dark);
    border-radius: 4px;
}

.position-btn {
    width: 100%;
    height: 100%;
    border: none;
    background: transparent;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}

.position-indicator {
    width: 70%;
    height: 70%;
    border-radius: 2px;
    transition: background-color 0.15s ease;
}

.position-box:hover .position-indicator {
    background-color: rgba(13, 110, 253, 0.5);
}

.position-box:active .position-indicator {
    background-color: #0d6efd;
}
</style>
